import { PkCountdown, PkCountdownTimer } from '@uefadigital/panenka-react';
import { useTranslation } from 'react-i18next';

import { diffBetweenDateAndNow } from '../../utils/utils';

const Countdown = ({
  datetime,
  heading,
  backgroundColor = 'background',
}: {
  datetime?: string;
  heading?: string;
  backgroundColor: string;
}) => {
  const { t } = useTranslation();
  const onPkDeadlineEnds = () => {
    const diffTime = Math.abs(diffBetweenDateAndNow(datetime));
    if (diffTime < 10000) {
      location.reload();
    }
  };

  return (
    <PkCountdown background-timer={backgroundColor} color='text-01'>
      {!!heading && (
        <h5 className='pk-text--center' slot='heading'>
          {t(heading)}
        </h5>
      )}
      <PkCountdownTimer
        onPkDeadlineEnds={onPkDeadlineEnds}
        daysLabel={t('days')}
        hoursLabel={t('hours')}
        minutesLabel={t('minutes')}
        secondsLabel={t('seconds')}
        deadline={datetime ?? new Date()}></PkCountdownTimer>
    </PkCountdown>
  );
};

export default Countdown;
